import axios from "axios";
import apiConfig from "../config/api.js";

const API_URL = apiConfig.baseURL;

// Fonction helper pour obtenir le token
const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Service pour gérer les fonctionnalités générales de la communauté
 */

const communityService = {
  /**
   * Récupérer les statistiques globales de la communauté
   * @returns {Promise} Statistiques
   */
  getCommunityStats: async () => {
    try {
      const response = await axios.get(`${API_URL}/community/stats`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des statistiques:", error);
      throw error.response?.data || error;
    }
  },

  /**
   * Récupérer les recettes les plus populaires
   * @param {number} limit - Limite de résultats
   * @param {string} period - Période (all, month, week)
   * @returns {Promise} Liste des recettes populaires
   */
  getTopRecipes: async (limit = 20, period = "all") => {
    try {
      const response = await axios.get(`${API_URL}/community/recipes/top`, {
        params: { limit, period },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des recettes:", error);
      throw error.response?.data || error;
    }
  },

  /**
   * Récupérer les utilisateurs les plus actifs
   * @param {number} limit - Limite de résultats
   * @param {string} sortBy - Critère de tri (score, recipes, followers, badges)
   * @returns {Promise} Liste des utilisateurs actifs
   */
  getTopUsers: async (limit = 20, sortBy = "score") => {
    try {
      const response = await axios.get(`${API_URL}/community/users/top`, {
        params: { limit, sortBy },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des utilisateurs:", error);
      throw error.response?.data || error;
    }
  },

  /**
   * Rechercher des utilisateurs
   * @param {string} query - Terme de recherche
   * @param {number} limit - Limite de résultats
   * @returns {Promise} Liste des utilisateurs trouvés
   */
  searchUsers: async (query, limit = 20) => {
    try {
      const response = await axios.get(`${API_URL}/community/users/search`, {
        params: { query, limit },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la recherche:", error);
      throw error.response?.data || error;
    }
  },

  /**
   * Récupérer les tendances du mois
   * @returns {Promise} Tendances
   */
  getMonthlyTrends: async () => {
    try {
      const response = await axios.get(`${API_URL}/community/trends/monthly`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des tendances:", error);
      throw error.response?.data || error;
    }
  },

  /**
   * Récupérer le fil d'actualité personnalisé
   * @param {number} limit - Limite de résultats
   * @param {number} offset - Offset pour la pagination
   * @returns {Promise} Fil d'actualité
   */
  getFeed: async (limit = 20, offset = 0) => {
    try {
      const response = await axios.get(`${API_URL}/community/feed`, {
        params: { limit, offset },
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération du feed:", error);
      throw error.response?.data || error;
    }
  },
};

export default communityService;
